module.exports = __webpack_public_path__ + "img/logo11.0b12fc09.png";